import script from "./log.vue?vue&type=script&setup=true&lang=js"
export * from "./log.vue?vue&type=script&setup=true&lang=js"

import "./log.vue?vue&type=style&index=0&id=7c8dac7c&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c8dac7c"]])

export default __exports__